import { red } from '@material-ui/core/colors';
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';

const themeV4 = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.88rem',
        fontWeight: 500,
      },
      contained: {
        padding: '0.5rem 1.5rem',
        boxShadow: 'none',
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: '#008ba3',
        }
      }
    },
    MuiInput: {
      root: {
        padding: '4px 12px',
        height: '36px',
        border: '1px solid #e8e7e7',
        borderRadius: '3px',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.03)',
        '&.Mui-focused': {
            border: '2px solid #00799B',
        }
      },
      underline: {
        '&:after': { borderBottom: 'none' },
        '&:before': { borderBottom: 'none' },
        '&:hover:not($disabled):before': { borderBottom: 'none' },
      },
    },
    // Fix: Cast these pickers overrides to any to avoid TS errors
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#00799B',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#005a73',
        }
      },
      current: {
        color: '#00799B',
      },
    },
    MuiPickersYear: {
      root: {
        '&:focus': { color: '#00799B' },
      },
      yearSelected: {
        color: '#00799B',
        fontWeight: 'bold',
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: '#ffffff',
        color: '#485c6e',
      },
    },
  } as any, // Cast to allow Pickers overrides
  palette: {
    primary: {
      main: '#00799b',
      dark: '#005a73',
    },
    secondary: {
      main: '#485c6e',
    },
    text: {
      primary: '#1b2024',
      secondary: '#485c6e',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  }
});

export default themeV4;